import { useCallback } from 'react'
import {
  ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	senmoniApi
} from 'interface/endpoints'
import {
	SenmoniResultList,
} from './types'

// 1日単位でのcacheTime
const cacheTime = Math.floor(new Date().getTime() / 86400000)

export const useListSenmoni = (
	searchId: number | null | undefined,
	word: string | null | undefined
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<SenmoniResultList>(
        apiAccess,
        senmoniApi('/list', { t: cacheTime, searchId, word }),
        cancelToken
      )
    },
		[searchId, word]
	)
)
